import { createFileRoute, redirect } from '@tanstack/react-router'

/** `/platform` is the editions list; the sidebar links here, so it stays a real address. */
export const Route = createFileRoute('/_authenticated/platform/')({
  beforeLoad: () => {
    throw redirect({
      to: '/platform/tenants',
      search: { q: '', status: '', plan: '', series: '' },
      replace: true,
    })
  },
})
